import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { DEFAULT_COLUMN, TRANSFER_MODULE } from '../constant/transferConstant';
import { Column } from '../objects/column';

export const setTransferPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: TRANSFER_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
